// test670
(670 && 0);
